var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddReceiverBizIconBlueSky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6 3.688C7.6 2.756 8.317 2 9.2 2h9.6c.883 0 1.6.756 1.6 1.688v14.676h.8c.442 0 .8.366.8.818a.81.81 0 0 1-.8.818H6.8a.81.81 0 0 1-.8-.818.81.81 0 0 1 .8-.818h.8V3.687Zm4.8 14.676h3.2V15.96c0-.931-.717-1.687-1.6-1.687-.883 0-1.6.756-1.6 1.687v2.404Zm-2.133-9c-.294 0-.534.253-.534.562v1.125c0 .31.24.563.534.563h1.066c.294 0 .534-.254.534-.563V9.926a.55.55 0 0 0-.534-.562h-1.066Zm4.266 0h-1.066c-.294 0-.534.253-.534.562v1.125c0 .31.24.563.534.563h1.066c.294 0 .534-.254.534-.563V9.926a.55.55 0 0 0-.534-.562Zm2.134 0c-.294 0-.534.253-.534.562v1.125c0 .31.24.563.534.563h1.066c.294 0 .534-.254.534-.563V9.926a.55.55 0 0 0-.534-.562h-1.066Zm-5.334-4.5h-1.066c-.294 0-.534.253-.534.562v1.125c0 .31.24.563.534.563h1.066c.294 0 .534-.253.534-.563V5.426a.55.55 0 0 0-.534-.562Zm2.134 0c-.294 0-.534.253-.534.562v1.125c0 .31.24.563.534.563h1.066c.294 0 .534-.253.534-.563V5.426a.55.55 0 0 0-.534-.562h-1.066Zm4.266 0h-1.066c-.294 0-.534.253-.534.562v1.125c0 .31.24.563.534.563h1.066c.294 0 .534-.253.534-.563V5.426a.55.55 0 0 0-.534-.562Z",
    fill: "#00AFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 17a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.333a4.667 4.667 0 1 0 0 9.334 4.667 4.667 0 0 0 0-9.334ZM1 17a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z",
    fill: "#00AFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.667 10.556 17 7 14.333v1.778H3.445v1.778H7v1.778Z",
    fill: "#00AFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddReceiverBizIconBlueSky);
export default __webpack_public_path__ + "static/media/add-receiver-biz-icon-blue-sky.0b477b8b7e3c14952e099c8648c524b5.svg";
export { ForwardRef as ReactComponent };